module.exports = __webpack_public_path__ + "static/media/social-good-podcast.0031318d.png";